import React from 'react';
import autoBind from 'react-autobind';

import { Row, Col } from 'react-bootstrap';

import GridFilterBase from './grid.filter.base';

import DecimalInput from '@common/components/inputs/decimal.component';
import DecimalFormat from '@common/components/formats/decimal.format';

import CONST_N from '@common/constraints/numbers.contraints';

const I = {
  DE: 0,
  ATE: 1,
};

class GridFilter extends GridFilterBase {
  constructor(props) {
    super(props, {
      de: { title: 'De:', type: 'decimal', operation: 'de', showInAdvancedSearch: true, advancedSearchValues: [] },
      ate: { title: 'Até:', type: 'decimal', operation: 'ate', showInAdvancedSearch: false },
    });
    autoBind(this);
  }

  getDefaultInputValues(column) {
    return {
      isDecimal: !!column.isDecimal,
      isNullable: !!column.isNullable,
      isLong: !!column.isLong,
      isNot: false,
      value: column.value,
      isShort: !!column.isShort,
      isByte: !!column.isByte,
    };
  }

  clearInputs(column) {
    const { inputs } = column;
    inputs.forEach((x) => {
      x.value = null;
      x.advancedSearchValues = [];
      x.isNot = false;
    });
  }

  handleChangeValue(index) {
    let { column } = this.props;
    return ({ maskedValue, floatValue }) => {
      column.inputs[index].value = maskedValue == '' ? null : floatValue;
      if (!column.showFaixa && !column.isAdvancedSearch) {
        column.inputs[I.ATE].value = column.inputs[I.DE].value;
      }
      this.updateContextColumn(column, false);
    };
  }

  isValidDeInput() {
    let { column } = this.props;
    let inputDe = column.inputs[I.DE];
    return parseFloat(inputDe.value) <= CONST_N.MAX_DECIMAL;
  }

  changeInputDeAte(column) {
    let inputDe = column.inputs[I.DE];
    let inputAte = column.inputs[I.ATE];

    if ((inputDe.value || inputDe.value == 0) && this.isValidDeInput()) {
      if (!inputAte.value || parseFloat(inputAte.value) < parseFloat(inputDe.value) || !column.showFaixa)
        inputAte.value = inputDe.value;
    }

    if (!inputDe.value && inputDe.value != 0 && column.showFaixa) {
      inputAte.value = null;
    }
  }

  async handleOnBlur() {
    let { column } = this.props;
    if (!column.isAdvancedSearch) {
      this.changeInputDeAte(column);
      await this.updateContextColumn(column, false);
    }
  }

  handleIsNot(e) {
    let { column } = this.props;
    let isNot = e.target.checked;
    column.inputs.forEach((x) => (x.isNot = isNot));
    this.updateContextColumn(column);
  }

  addAdvancedSearch(index, ignoreEmpty) {
    let { column } = this.props;
    return (e) => {
      let input = column.inputs[index];
      if (!input.value && input.value !== 0) {
        if (!ignoreEmpty) _alert.warning('Digite um termo a ser pesquisado.');
        return;
      }
      input.advancedSearchValues = [...input.advancedSearchValues, input.value];
      input.value = null;
      this.updateContextColumn(column);
    };
  }

  onSubmit() {
    let { column } = this.props;
    if (column.isAdvancedSearch) {
      let inputDe = column.inputs[I.DE];
      if (inputDe || inputDe == '0') {
        this.addAdvancedSearch(0, true)();
      }
    }
  }

  removeAdvancedSearch(indexInput, index) {
    let { column } = this.props;
    return (e) => {
      let inputItem = column.inputs[indexInput];
      inputItem.advancedSearchValues.splice(index, 1);
      this.updateContextColumn(column);
    };
  }

  changeAdvancedSearch() {
    let { column } = this.props;
    column.isAdvancedSearch = !column.isAdvancedSearch;
    this.clearInputs(column);
    this.updateContextColumn(column, false);
  }

  changeShowFaixa() {
    let { column } = this.props;
    column.showFaixa = !column.showFaixa;
    this.changeInputDeAte(column);
    this.updateContextColumn(column, false);
  }

  render() {
    const { column } = this.props;
    const { isAdvancedSearch, inputs } = column;

    if (!inputs) return null;

    return (
      <ul>
        {inputs.map(this.renderInput)}
        {!isAdvancedSearch && (
          <a onClick={this.changeShowFaixa}>
            <span>{column.showFaixa ? 'Busca por Coincidentes' : 'Busca por Faixa'}</span>
          </a>
        )}
        <p className="advanced-search" onClick={this.changeAdvancedSearch}>
          <span>{isAdvancedSearch ? 'Retornar para a busca simples' : 'Busca avançada'}</span>
        </p>
      </ul>
    );
  }

  renderInput(input, index) {
    const { column, hash } = this.props;
    const { isAdvancedSearch, showFaixa, inputs } = column;
    if (index == I.ATE && (!showFaixa || isAdvancedSearch)) return;
    return (
      <li className="filterLine" key={index}>
        <div className="filterColunm">
          <label htmlFor="input">
            {isAdvancedSearch ? 'Pesquisar Por:' : index == I.DE && !column.showFaixa ? 'Igual:' : input.title}
          </label>
          <Row>
            <Col lg={isAdvancedSearch ? 10 : 12}>
              <DecimalInput
                name={hash}
                value={input.value}
                className="form-control text-right"
                places={column.places || 2}
                tamanho={column.tamanho || 17}
                onValueChange={this.handleChangeValue(index)}
                onBlur={this.handleOnBlur}
              />
            </Col>
            {isAdvancedSearch && (
              <Col lg={1}>
                <button type="button" className="btn btn-primary btn-custom" onClick={this.addAdvancedSearch(index)}>
                  <i className="fa fa-plus" />
                </button>
              </Col>
            )}
          </Row>
          {isAdvancedSearch && (
            <Row>
              <Col lg={12}>
                <label className="advanced-search-label">Termos pesquisados</label>
                <ul className="advanced-search-list">
                  {input.advancedSearchValues == 0 && (
                    <li className="empty-message">Não há termos a serem pesquisados.</li>
                  )}

                  {input.advancedSearchValues.map((item, i) => (
                    <li key={i}>
                      <i
                        className="fa fa-times-circle"
                        title={'Remover da Busca Avançada'}
                        onClick={this.removeAdvancedSearch(index, i)}
                      />{' '}
                      <span
                        title={(item || 0).toLocaleString(navigator.language, {
                          minimumFractionDigits: column.places || 2,
                        })}
                      >
                        {(item || 0).toLocaleString(navigator.language, {
                          minimumFractionDigits: column.places || 2,
                        })}
                      </span>
                    </li>
                  ))}
                </ul>
              </Col>
            </Row>
          )}
          {isAdvancedSearch && (
            <div className="filterColunm mt-2">
              <label className="checkbox">
                <input className="mt-0" type="checkbox" value={input.isNot || false} onChange={this.handleIsNot} />{' '}
                Registros não coincidentes
              </label>
            </div>
          )}
        </div>
      </li>
    );
  }
}

export default GridFilter;
